import React from 'react';
import { Redirect } from 'react-router-dom';
import { reduxForm, Field } from 'redux-form';

import CheckboxField from './CheckboxField';
import { formatSaveStatus } from '../helpers/formatters';
import FormError from './FormError';

let DeviceCancel = ({ handleSubmit, saveStatus, error, contractId }) => {
  if (saveStatus === 'SUCCEEDED') {
    return <Redirect to={`/device-protection/contracts/${contractId}/view`} />;
  }

  return (
    <div>
      <h3>Cancel Contract</h3>
      <form onSubmit={handleSubmit}>
        <Field
          component={CheckboxField}
          name="cancel_contract"
          label="Cancel Contract"
        />

        <button className="btn btn-danger" disabled={saveStatus === 'PENDING'}>
          Cancel Contract
        </button>

        {error && <FormError error={error} />}

        <span className="submit-status">{formatSaveStatus(saveStatus)}</span>
      </form>
    </div>
  );
};

DeviceCancel = reduxForm({
  form: 'contractCancel',
})(DeviceCancel);

export default DeviceCancel;
